import * as Common from '@/tenant/common';

export class ReceivePaymentScheduledReportQuery extends Common.Query {
    constructor(){
        super("ReceivePaymentScheduledReportQuery", null);
    }
    public templateId:number=0;
    public counterpart: Common.Counterpart = null;
    public segment: Common.Segment = null;
    public slipType:number = null;
    public isIncludeBalanceZero:boolean = false;
    public startDate: Date = null;
    public endDate: Date = null;
    public onExcelExport:boolean = false;           
}

export class ReceivePaymentScheduledReportTemplateQuery extends Common.ReportTemplateQuery {
  queryName ='ReceivePaymentScheduledReportQuery';
  sort = 'id';
  constructor() {
    super();
  }
}